define([
	"csi/def",
	"csi/def/Action",
	"csi/view/ToolbarPluginFile",
	"csi/reflection",
	"csi/state/rootStore",
	"dojo/_base/lang",
	"./_Plugin",
	"./PluginFactory"
], function (def, Action, ToolbarPluginFile, reflection, { sessionStore }, lang, _Plugin, PluginFactory) {

	return PluginFactory.declare([ToolbarPluginFile, _Plugin], {
		"class": "csi-canvas-rightpane-uploadbtn",
		pluginName: "imageupload",
		title: "UploadImage",

		postMixInProperties: function () {
			if (!this.defAction) {
				var editor = this.editor;
				var action = lang.mixin(new Action(), {
					classController: "csi/action/NewFileController",
					m_id: "Upload",
					m_class: "iconUpload",
					m_preAction: function (/*Controller*/ac) {
						// indicate that uploaded files need to be wrapped with image nodes
						ac.typeNode = reflection.TYPE_IMAGE;
						ac.prepend = true;
						return true;
					},
					m_postAction: function (/*Controller*/ac) {
						// add new images to upload store and updates the myUploads right grid
						editor.view.updateGridRightUpload(ac.getNewFileNodes());
					},
					m_typeControl: def.ACTION_ICON
				});
				action.resolve();

				this.defAction = action;
			}

			this.inherited(arguments);
		}
	});
});